import { endpoints } from '../../api/config'
import { callApi } from '../../utils/api'

export const confirmEmail = async (guid: string, salonGuid: string) => {
  const response = await callApi({ path: `${endpoints.confirmEmail}?guid=${guid}&refSalonGuid=${salonGuid}` })

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
